import FormPackageCommissionTableField from './fields/Form/PackageCommissionTableField.vue'

const affiliateModuleSetup = (app) => {
    app.component('form-package-commission-table-field', FormPackageCommissionTableField)
}

export { affiliateModuleSetup }
